import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@material-ui/core';
import { SpeedDial } from '@material-ui/lab';
import { BackBlackIcon } from 'sharedComponents/Icons';
import { OFFSET_TOP_TO_SHOW_BACK_TO_TOP } from 'constants/index';

const BackToTop = ({ classes, children, targetRef, onClick }) => {
  const [scrollTop, setScrollTop] = React.useState(false);
  const isBackToTopEnabled = React.useRef(false);

  React.useEffect(() => {
    const handleScroll = (e) => {
      if (e.target.scrollTop > OFFSET_TOP_TO_SHOW_BACK_TO_TOP && !isBackToTopEnabled.current) {
        setScrollTop(true);
        isBackToTopEnabled.current = true;
      } else if (e.target.scrollTop <= OFFSET_TOP_TO_SHOW_BACK_TO_TOP && isBackToTopEnabled.current) {
        setScrollTop(false);
        isBackToTopEnabled.current = false;
      }
    };

    window.addEventListener('scroll', handleScroll, true);
    return () => window.removeEventListener('scroll', handleScroll, true);
  }, []);

  const handleClick = () => {
    if (targetRef) {
      targetRef.current.scrollIntoView(true);
    }

    if (typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <>
      {children}
      {scrollTop && (
        <SpeedDial
          open={false}
          onClick={handleClick}
          ariaLabel="back-to-top-button"
          data-testid="back-to-top-button"
          classes={{ root: classes.backToTop, fab: classes.fab }}
          icon={<Icon component={BackBlackIcon} className={classes.arrowIcon} />}
        />
      )}
    </>
  );
};

BackToTop.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
};

BackToTop.defaultProps = {
  children: '',
};

export default BackToTop;
